// extracted by mini-css-extract-plugin
export default {"container":"page_container__Y-uxw","loader":"page_loader__0dIdq","loader__icon":"page_loader__icon__UiJDo"};